import { render, staticRenderFns } from "./page2-2.vue?vue&type=template&id=6f17f65a&scoped=true&"
import script from "./page2-2.vue?vue&type=script&lang=js&"
export * from "./page2-2.vue?vue&type=script&lang=js&"
import style0 from "./page2-2.vue?vue&type=style&index=0&id=6f17f65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f17f65a",
  null
  
)

export default component.exports